import { Paper } from "@mui/material";
import { AppContext } from "App";
import React, { useContext } from "react";
import Barcode from "react-barcode";

const PreviewLabel = ({ values }) => {
  const { settings } = useContext(AppContext);
  return (
    <div className="w-fit">
      <Paper className="w-64 bg-white p-4 font-mono shadow-sm border !border-gray-200">
        {/* Store Name */}
        {values.showOutlet && (
          <div className="text-center font-bold text-lg leading-3">
            Store Name
          </div>
        )}

        {/* Barcode */}
        <div className="flex justify-center">
          <Barcode
            value="3039438"
            width={1.8}
            height={45}
            displayValue={false}
            format="CODE128"
          />
        </div>

        {/* SKU/Numbers */}
        {values.showSku && (
          <div className="text-center text-sm leading-3 mb-[4px]">3039438</div>
        )}

        {/* Product Label */}
        {values.showProdTitle && (
          <div className="text-center text-sm">
            Fmami7Oin1.M.OI+C.S.B170ml G100mlOF
          </div>
        )}

        {/* Price */}
        {values.showRtlPrice && (
          <div className="text-center font-bold text-md">
            MRP {settings?.currSymbol} 280.00
          </div>
        )}
      </Paper>
      <div className="text-center">
        <span className="text-[14px] uppercase font-bold text-gray-500 tracking-wider">
          Barcode Preview
        </span>
      </div>
    </div>
  );
};

export default PreviewLabel;
